
import {IHttpService, ILogService, IPromise} from "angular";
import {Application} from "../model/Application";

export class LogService {

    /* @ngInject */
    constructor(private $http: IHttpService,
                private $log: ILogService) {
    }

    public logWarn(error: any, method: string, url: string, data: any): void {

        this.$log.debug("%s data %o to %s", method, data, url);

        this.$http.post("/api/client/log/warns/",
            {
                message: JSON.stringify(error),
                method: method,
                resourceUrl: url,
                data: this.stringify(data)
            });

        return;
    }

    public logErrorOfAny(error: any, method: string, url: string, data: any): void {

        this.$log.debug("%s data %o to %s", method, data, url);

        this.$http.post("/api/client/log/errors/",
            {
                message: JSON.stringify(error),
                method: method,
                resourceUrl: url,
                data: this.stringify(data)
            });

        return;
    }

    public logError(error: any, method: string, url: string, application: Application): void {

        this.$log.debug("%s data %o to %s", method, application, url);

        this.$http.post("/api/client/log/errors/",
            {
                message: JSON.stringify(error),
                method: method,
                resourceUrl: url,
                data: this.stringify(application)
            });

        return;
    }

    private stringify(application: Application): string {
        return this.base64Encode(JSON.stringify(application));
    }

    private base64Encode(value: string): string {
        return btoa(value);
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/main/client/app/shared/log/log.service.ts